import { MintVectorStatus } from "apollo/graphql.generated";
import * as Types from "apollo/graphql.generated";
import { getNumberOfDays } from "utils/date";

export enum SaleStatus {
  NOT_STARTED = "NOT_STARTED",
  ACTIVE = "ACTIVE",
  ENDED = "ENDED",
  PAUSED = "PAUSED",
  SOLD_OUT = "SOLD_OUT",
  NEEDS_FULFILLMENT = "NEEDS_FULFILLMENT",
  RESERVE_NOT_MET = "RESERVE_NOT_MET",
}

export enum SaleAvailability {
  RESTART = "RESTART",
  PAUSE = "PAUSE",
}

export interface MintVector {
  id: string;
  startDate: string;
  endDate: string | null;
  price: string;
  chainId: string;
  maxPerUser: number;
  collectionId: string;
  gateId: string | null;
  isDirectMint: boolean | null;
}

export const getStartsInLabel = (startDate: Date) => {
  const numberOfDays = getNumberOfDays(startDate, new Date());
  if (numberOfDays === 0) return "today";
  if (numberOfDays === 1) return "tomorrow";
  return `in ${numberOfDays} days`;
};

export const getSaleStatus = (
  mintVector?: {
    paused: boolean | null;
    stats: {
      total: number;
      sold: number;
      status: Types.MintVectorStatus;
      earned: string | null;
    } | null;
  } | null,
  collection?: {
    supply: number | null;
    size: number | null;
  },
  options: {
    ignorePaused?: boolean;
  } = {}
) => {
  const mergedOptions = {
    ignorePaused: false,
    ...options,
  };
  if (
    !!collection?.size &&
    (collection?.supply ?? 0) >= (collection?.size ?? 0)
  )
    return SaleStatus.SOLD_OUT;

  const stats = mintVector?.stats;
  if (!stats) return SaleStatus.ACTIVE;

  if (stats.total && stats.sold >= stats.total) {
    return SaleStatus.SOLD_OUT;
  }

  if (!!mintVector.paused && !mergedOptions.ignorePaused) {
    return SaleStatus.PAUSED;
  }

  switch (stats.status) {
    case MintVectorStatus.Ended:
      return SaleStatus.ENDED;
    case MintVectorStatus.InProgress:
      return SaleStatus.ACTIVE;
    case MintVectorStatus.NotStarted:
      return SaleStatus.NOT_STARTED;
  }
};
